import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "adam-favorites";

function readFavorites(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const persist = useCallback((next: string[]) => {
    setFavorites(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // ignore storage errors (private mode, quota, etc.)
    }
  }, []);

  const toggle = useCallback(
    (id: string) => {
      const current = readFavorites();
      const next = current.includes(id) ? current.filter((x) => x !== id) : [...current, id];
      persist(next);
      return next.includes(id);
    },
    [persist],
  );

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  const remove = useCallback(
    (id: string) => {
      persist(readFavorites().filter((x) => x !== id));
    },
    [persist],
  );

  return { favorites, toggle, isFavorite, remove };
}